

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const EVENTPOST= createAsyncThunk(
  "EventPost/EventPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const EventPostSlice = createSlice({
  name: "EventPostSlice",
  initialState: {
    EventPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfEventPost: (state) => {
        state.EventPost.loading = false
        state.EventPost.error = false
        state.EventPost.data = []
        state.EventPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(EVENTPOST.fulfilled, (state, action) => {
      state.EventPost = {
        ...state.EventPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EVENTPOST.pending, (state, action) => {
      state.EventPost = {
        ...state.EventPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EVENTPOST.rejected, (state, action) => {
      state.EventPost = {
        ...state.EventPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const EventPostAction = {
    EVENTPOST,
};

export { EventPostAction };
export default EventPostSlice.reducer;
export const {setInitialStateOfEventPost} = EventPostSlice.actions
